import { c as _c } from "react/compiler-runtime";
import { type RefObject } from 'react';
import { CLICK_OUTSIDE_IGNORE_ATTR } from '@/app/components/overlays/hooks/useClickOutside';
import { CONTENT_HUB_DATA_TEST } from '@/app/components/sections/content-hub/tracking';
import type { ContentHubEntry } from '@/app/components/sections/content-hub/types';
import { SocialMediaShareGroup } from '@/app/components/social-media/share-group';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
interface FooterProps {
  experienceRef: RefObject<HTMLDivElement | null>;
  category: string;
  item: ContentHubEntry;
}
export const ContentFooter = t0 => {
  const $ = _c(9);
  const {
    experienceRef,
    category,
    item
  } = t0;
  let t1;
  if ($[0] !== category) {
    t1 = category === "inspiration" && <div className="flex justify-center p-4"><SocialMediaShareGroup theme="light" restToastProps={{
        [CLICK_OUTSIDE_IGNORE_ATTR]: "true"
      }} /></div>;
    $[0] = category;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== category || $[3] !== experienceRef || $[4] !== item) {
    t2 = category === "experiences" && !!item && <div ref={experienceRef} className="md:px-10"><div className="flex flex-col justify-center gap-6 p-4 md:flex-row md:justify-between md:gap-x-30"><div className="w-full"><p className="text-body-1 font-noto-bold" dangerouslySetInnerHTML={{
            __html: item.title
          }} {...createDataAttributes({
            test: `${CONTENT_HUB_DATA_TEST.modal}-name`
          })} /><div className="text-body-2" dangerouslySetInnerHTML={{
            __html: item.detail
          }} {...createDataAttributes({
            test: `${CONTENT_HUB_DATA_TEST.modal}-detail`
          })} />{!!item.author && <figcaption className="text-caption mt-2" {...createDataAttributes({
            test: `${CONTENT_HUB_DATA_TEST.modal}-author`
          })}>by <strong>{item.author}</strong></figcaption>}</div><SocialMediaShareGroup theme="light" className="shrink-0 items-start" restToastProps={{
          [CLICK_OUTSIDE_IGNORE_ATTR]: "true"
        }} /></div></div>;
    $[2] = category;
    $[3] = experienceRef;
    $[4] = item;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};